import { useEffect } from 'react';

export const useScript = ({ url, shouldAppendScript }) => {
  useEffect(() => {
    if (!shouldAppendScript) { return; }

    // Check if script has not been added yet
    if (document.querySelector(`script[src="${url}"]`)) { return; }

    const script = document.createElement('script');

    script.src = url;
    script.async = true;

    document.body.appendChild(script);
  }, [url, shouldAppendScript]);
};
